import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import exact from 'prop-types-exact';
import { setProfileModalState } from '../../components/profile/actions/ProfileActions';
import Button from '../button/Button';
import { showInfo } from '../A1Alert/A1Alert';

const DownloadButtonComponent = (props) => {
    const _handleButtonClick = (event) => {
        event.preventDefault();

        event.stopPropagation();

        if (!props.isLogged) {
            showInfo('É necessário estar logado para efetuar o download.');

            return props.setProfileModalState(true);
        }

        const downloadUrl = `api/v1/downloads/${props.fileType}/${props.fileId}`;
        // Note: the following is calling an authenticated route and this is only working because the server checks for the auth cookie
        const link = document.createElement('a'); // create invisbile 'a' element

        link.setAttribute('href', downloadUrl);

        link.setAttribute('download', downloadUrl);

        link.click(); // virtually click <a> element to initiate download
        // @TODO remove the element after clicking it?!

        return true;
    };

    return (
        <Button title="Baixar essa música" className={`downloadButton ${props.isLogged ? '' : 'disabled'}`} onClick={_handleButtonClick}>
            BAIXAR
        </Button>
    );
};

DownloadButtonComponent.propTypes = exact({
    setProfileModalState: PropTypes.func.isRequired,
    isLogged: PropTypes.bool.isRequired,
    fileType: PropTypes.string.isRequired,
    fileId: PropTypes.string.isRequired,
});

const mapStateToProps = (state) => ({
    isLogged: !!state.profile.jwt,
});
const mapDispatchToProps = (dispatch) => ({
    setProfileModalState: (open) => {
        dispatch(setProfileModalState(open));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadButtonComponent);
